import { DueDiligenceApprovalStatus } from '@/utils/Enumerations.js'
import { dueDiligenceApprovalEnabled, dueDiligenceGatesBids } from '@/utils/dueDiligence/mode.js'

export function isTractExempt (exemption, latestApproval, approvalRequirementActive = dueDiligenceApprovalEnabled()) {
  if (!exemption) return false
  if (!exemption.requiresApproval || !approvalRequirementActive) return true
  return latestApproval?.status === DueDiligenceApprovalStatus.Approved.value
}

// Mirrors TractService.IsTractDueDiligenceClearedAsync, which the server enforces when a bid is
// created against a tract. The gate exists only in Strict mode. Advisory only — the server stays
// the authority on the gate.
export function isTractCleared (tract, approvalRequirementActive = dueDiligenceGatesBids()) {
  if (!approvalRequirementActive) return true

  const latestApproval = tract?.latestDueDiligenceApproval ?? null
  return latestApproval?.status === DueDiligenceApprovalStatus.Approved.value ||
    isTractExempt(tract?.dueDiligenceExemption ?? null, latestApproval, true)
}
